import React, { useMemo } from 'react';
import PageShell from '../components/PageShell';
import ViewSwitch from '../components/ViewSwitch';
import { usePersistentValue } from '../hooks/usePersistentState';
import { useP } from '../i18n/useP';
import CashFlowPage from './CashFlowPage';

/* Cash flow — écran unique de la section Rapports (2026-08-11) : la VUE
   (Réel | Prévisionnel) sur le filet, l'unité à droite. Pas de modes : le
   tableau de flux ne se saisit pas, il CONSTATE — les deux vues sortent du
   même moteur serveur (réel pur, ou 12 mois adossés au bilan hybride). */
export default function CashFlowCommandPage({ activeTenant, addToast, year, onYearChange }) {
  const p = useP();
  const tid = activeTenant?.id;
  const [vue, setVue] = usePersistentValue(`cf_vue_${tid}`, 'reel');
  const [unit, setUnit] = usePersistentValue(`cf_cmd_unit_${tid}`, 'kchf');
  /* L'unité monte à la BANDE DE CONTEXTE, comme partout ailleurs (2026-09-18) :
     elle tenait la droite de la ligne des modes, où elle changeait de place
     d'un écran à l'autre. Le gabarit la place, la page la déclare. */
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);
  const [detail, setDetail] = usePersistentValue(`cf_detail_${tid}`, true);

  return (
    <PageShell framed kind="report" unit={pageUnit} title={p('Flux de trésorerie')}>
      <nav className="tabs">
        <div className="tabs__list">
          <ViewSwitch
            ariaLabel={p('Vue')}
            value={vue}
            onChange={setVue}
            options={[{ id: 'reel', label: p('Réel') }, { id: 'prev', label: p('Prévisionnel') }]}
          />
          <ViewSwitch
            ariaLabel={p('Colonnes')}
            value={detail ? 'detail' : 'totaux'}
            onChange={(v) => setDetail(v === 'detail')}
            options={[{ id: 'totaux', label: p('Totaux') }, { id: 'detail', label: p('Détail mensuel') }]}
          />
        </div>
      </nav>
      <div className="page-shell__panel">
        <CashFlowPage embedded actualsOnly forecastView={vue === 'prev'} unit={unit}
          monthsDetail={detail}
          activeTenant={activeTenant} addToast={addToast} year={year} onYearChange={onYearChange} />
      </div>
    </PageShell>
  );
}
